import { Pipe, PipeTransform } from '@angular/core';
import { AddressModel } from '../../models';
import { ActiveCompartmentsModel } from '../../../store/state/monitoring/allocation-view';

@Pipe({
  name: 'findFilteredCompartmentName',
})
export class UliFindFilteredCompartmentNamePipe implements PipeTransform {
  transform(compartments: ActiveCompartmentsModel[], compartmentAddress: AddressModel): string {
    return compartmentAddress
      ? compartments?.find((compartment: ActiveCompartmentsModel) =>
          compartment.compartmentAddresses.some(
            (address: AddressModel) => address.addressExtId === compartmentAddress.addressExtId,
          ),
        )?.name
      : '';
  }
}
